import { useAuth0 } from '@auth0/auth0-react';
import { Avatar, Group, Menu, Text, UnstyledButton, createStyles } from '@mantine/core';
import { IconChevronDown, IconLogout } from '@tabler/icons';

const useStyles = createStyles((theme) => ({
  trigger: {
    padding: '4px 10px 4px 4px',
    borderRadius: theme.radius.md,
    transition: 'background-color 0.15s ease',

    '&:hover': {
      backgroundColor: theme.colors.gray[0],
    },
  },

  label: {
    maxWidth: 180,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export function UserMenu() {
  const { user, logout } = useAuth0();
  const { classes } = useStyles();

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  const display = user?.email ?? user?.name ?? 'User';
  const initials = display.charAt(0).toUpperCase();

  return (
    <Menu position="bottom-end" shadow="md" width={240} withinPortal>
      <Menu.Target>
        <UnstyledButton className={classes.trigger}>
          <Group spacing="xs" noWrap>
            <Avatar src={user?.picture} size="sm" color="bagel" radius="xl">
              {initials}
            </Avatar>
            <Text size="sm" className={classes.label}>
              {display}
            </Text>
            <IconChevronDown size={14} stroke={2} />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{user?.name ?? user?.email}</Menu.Label>
        <Menu.Divider />
        <Menu.Item icon={<IconLogout size={14} />} onClick={handleLogout} color="red">
          Log out
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
